import React from "react";
import MusicMayhem from "./components/MusicMayhem";

function App() {
  return (
    <>
      <MusicMayhem />
    </>
  );
}

export default App;
